import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'AGENDA_MODO_TELA',
        payload: {
			modo: modo,
			registro: {
				...registro
				
			}
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('agendaForm', {
			...registro,
			data_inicial: DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(registro.data_inicial))           

		})
    ];
}

export function setAguardando(aguardando) {
    return {
        type: 'AGENDA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/agenda`);
    return {
        type: 'AGENDA_LISTADO',
        payload: request
    };
}

export function getListaUsuario() {
    const request = axios.get(`${consts.API_URL}/usuario/listarSelect`);
    return {
        type: 'AGENDA_USUARIO_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/agenda`, {
				...registro,
                id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id,
				data_inicial: DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(registro.data_inicial))    
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/agenda`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id,
				data_inicial: DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(registro.data_inicial))   
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/agenda?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}
